import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

/**
 * Latido de "en línea": global, atado a la sesión iniciada y no al portal.
 *
 * Antes la presencia (presencia_usuario) solo se refrescaba con el latido de
 * PortalTrackingProvider, que no montan el panel admin ni varios portales (Tickets,
 * Productos...): quien trabajaba ahí salía "fuera de línea, hace N horas" con la
 * sesión abierta. Este latido corre en cualquier pantalla con sesión, cada 60 s y al
 * volver a la pestaña o a la red. La RPC `latido_presencia` es idempotente y solo
 * toca la fila del propio usuario; un fallo se ignora (la presencia es informativa).
 */
const LATIDO_MS = 60_000;

export function useLatidoPresencia(): void {
  const { user } = useAuth();
  const uid = user?.id ?? null;

  useEffect(() => {
    if (!uid) return;
    const latir = () => {
      void (supabase as any).rpc("latido_presencia").then(
        () => undefined,
        () => undefined,
      );
    };
    latir();
    const intervalo = setInterval(latir, LATIDO_MS);
    const alVolver = () => {
      if (document.visibilityState === "visible") latir();
    };
    document.addEventListener("visibilitychange", alVolver);
    window.addEventListener("online", alVolver);
    return () => {
      clearInterval(intervalo);
      document.removeEventListener("visibilitychange", alVolver);
      window.removeEventListener("online", alVolver);
    };
  }, [uid]);
}

/** Monta el latido una vez, justo dentro de AuthProvider. No pinta nada. */
export function LatidoPresencia(): null {
  useLatidoPresencia();
  return null;
}
